module.exports = __webpack_public_path__ + "src/assets/games/45/tuzi.gif";